export default __webpack_public_path__ + "static/media/logo.109cb40f.png";